import React from 'react'
import { useQueryParams } from 'use-query-params'
const FilterContext = React.createContext()

export const SearchParamsHandlerProvider = ({ children, queryParams }) => {
  const [value, set] = useQueryParams(queryParams)

  const setQuery = (key, newValue) => {
    set({ ...value, [key]: newValue })
  }

  const setQueries = filters => {
    set({ ...value, ...filters })
  }

  return (
    <FilterContext.Provider value={{ query: value, setQuery, setQueries }}>
      {children}
    </FilterContext.Provider>
  )
}

export const useSearchParamsHandler = () => {
  const context = React.useContext(FilterContext)
  if (!context) {
    throw new Error(
      'useSearchParamsHandler must be used within a SearchParamsHandlerProvider'
    )
  }
  return {
    query: context.query,
    setQuery: context.setQuery,
    setQueries: context.setQueries,
  }
}
